import { IMissionPlanWaypoint } from "../iris/missionPlan/IMissionPlanWaypoint"
import { MissionPlanUiState } from "./MissionPlanUiState"
import { SimulationTabs } from "./SimulationTabs"

export class CoverageUiState {
    
    public typeUiid:string        
    public drawMode:string //mode d'ajout de point step or wpt // = ""
    public hoverWptKey:string
    public hoverAreaId:number
    public editAreaId:number
    public currentEditWpt:IMissionPlanWaypoint    
    public showGlobalWpts:boolean
    public areaHidden:{[index:number]:boolean}
    public saving:boolean
    public runningGrid:boolean
    public runningCoverage:boolean
    public selectedCoverageId:number|null
    

    constructor({typeUiid="detail", //detail ou global ou fleet
                 drawMode = "",
                 showGlobalWpts = false,
                 hoverWptKey= "",
                 hoverAreaId=-1,
                 editAreaId=-1,
                 currentEditWpt= MissionPlanUiState.getDefaultWayPoint(),
                 areaHidden = {},
                 saving = false,
                 runningGrid= false,
                 runningCoverage=false
                } = {}) {
        this.typeUiid = typeUiid                            
        this.drawMode = drawMode
        this.hoverWptKey = hoverWptKey
        this.hoverAreaId = hoverAreaId
        this.editAreaId = editAreaId
        this.currentEditWpt = currentEditWpt
        this.showGlobalWpts = showGlobalWpts
        this.areaHidden = areaHidden
        this.saving = saving
        this.runningGrid = runningGrid
        this.runningCoverage = runningCoverage
        this.selectedCoverageId = null
    }
} 

export const buildCoverageStateId = (MIG_ID:number,typeuiid:string) => {
    return `coverage_${MIG_ID}_${typeuiid}`
}

